import styled from 'styled-components';
import { Button } from '../Button/Button';
import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import { Paragraph } from '../Paragraph/Paragraph';
import CoveragePriceCircle from './Components/CoveragePriceCircle/CoveragePriceCircle';
import MiddleSection from './Components/MiddleSection/MiddleSection';

interface TIProps {
  mainProductPriceWithEHIC?: number;
  mainProductPriceWithoutEHIC?: number;
}

const TravelInsurance = ({ mainProductPriceWithoutEHIC, mainProductPriceWithEHIC }: TIProps) => {
  const title = 'Choose your insurance';
  const paragraphText =
    'The most complete coverage when you travel in Europe for your exchange adventure';
  const buttonText = 'Get covered now';
  const bottomParagraph =
    'No commitments. You can cancel within 14 days of purchase and before your trip begins.';
  const buttonId = 'Travel_Insurance_Button';
  const textBottom = 'It takes less than 3 minutes';
  const smallParagraph =
    '*European Health Insurance Card or any other medical insurance with international coverage';
  const coveragePriceParagraph = `Note that EHIC rules can vary by country, and your card must be valid throughout your trip to ensure full coverage.`;

  return (
    <Wrapper>
      <LandingWrapper>
        <HeaderWrapper titleText={title} paragraphText={paragraphText} color='dark' />
        <CoveragePriceCircle
          mainProductPriceWithoutEHIC={mainProductPriceWithoutEHIC}
          mainProductPriceWithEHIC={mainProductPriceWithEHIC}
        />
        <SmallParagraph text={smallParagraph} />
        <WrapperParagraph>
          <Paragraph text={coveragePriceParagraph} maxWidth='1036px' />
        </WrapperParagraph>
        <MiddleSection />
        <WrapperButton>
          <Button href='/onboarding' maxWidth='430px' id={buttonId}>
            {buttonText}
          </Button>
          <TextBottom text={textBottom} color='dark' />
        </WrapperButton>
        <Paragraph text={bottomParagraph} color='dark' />
      </LandingWrapper>
    </Wrapper>
  );
};

export default TravelInsurance;

const Wrapper = styled.div`
  padding: 300px 0 15px 0;

  @media (min-width: 540px) {
    padding: 350px 0 100px 0;
  }

  @media (min-width: 768px) {
    padding: 400px 0 100px 0;
  }
  @media (min-width: 1024px) {
    padding: 450px 0 100px 0;
  }
`;

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0 20px 0;

  @media (min-width: 768px) {
    padding: 79px 0 30px 0;
  }
  @media (min-width: 1024px) {
    padding: 110px 0 38px 0;
  }
`;

const WrapperParagraph = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextBottom = styled(Paragraph)`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  margin-top: 10px !important;
`;

const SmallParagraph = styled(Paragraph)`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  max-width: 450px !important;
  padding-bottom: 20px;

  @media (min-width: 768px) {
    padding-bottom: 50px;
    font-size: 16px;
    max-width: 500px !important;
  }
  @media (min-width: 1024px) {
    padding-bottom: 70px;
  }
`;
